import {
    CLEAR_FILTER,
    PARENT_FILTERS_CHANGED,
    RESET_ALL_FILTERS,
    SELECT_TRANSFER_TIME_FILTER,
    SET_SELECTED_URL_FILTERS,
    TRANSFER_TIME_RECEIVED
} from "../../actions/FlightsActions";

export const initialState = {
    selected: 0,
    max: 0
};

const TransferTimeFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case TRANSFER_TIME_RECEIVED:
            return {
                ...state,
                selected: state.selected === state.max && state.selected !== initialState.selected ? action.time : state.selected,
                max: action.time
            };
        case SELECT_TRANSFER_TIME_FILTER:
            return {
                ...state, selected: action.time
            };
        case SET_SELECTED_URL_FILTERS:
            if (action.name === 'transfer') {
                return {
                    ...state,
                    selected: action.payload,
                };
            }

            return state;
        case PARENT_FILTERS_CHANGED:
            if (parseInt(action.filters.transfer, 10) > 0) {
                return {...state,
                    selected: action.filters.transfer
                };
            }

            return state;
        case CLEAR_FILTER:
            if (action.filter === 'transfer') {
                return {...state, selected: state.max};
            }

            return state;
        case RESET_ALL_FILTERS:
            return {...state, selected: initialState.selected};
        default:
            return state
    }
};

export default TransferTimeFilterReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/TransferTimeFilterReducer.js